import { IMenuElement } from "@dhx/ts-navbar";
import locale from "./../locales/en";

export function getContextMenuStruct() {
	return [
		{ id: "lock", value: locale.lockCell, icon: "dxi dxi-key" },
		{
			id: "clear",
			value: locale.clear,
			icon: "dxi dxi-eraser",
			items: [
				{
					id: "clear-value",
					value: locale.clearValue,
				},
				{
					id: "clear-styles",
					value: locale.clearStyles,
				},
				{
					id: "clear-all",
					value: locale.clearAll,
				},
			],
		},
		{
			id: "columns",
			value: locale.columns,
			icon: "dxi dxi-table-column",
			items: [
				{
					id: "add-col",
					value: locale.addColumn,
					icon: "dxi dxi-table-column-plus-before",
				},
				{
					id: "remove-col",
					value: locale.removeColumn,
					icon: "dxi dxi-table-column-remove",
				},
				{
					id: "fit-col",
					value: locale.fitToData,
					hidden: true,
					icon: "dxi dxi-table-column"
				}
			],
		},
		{
			id: "rows",
			value: locale.rows,
			icon: "dxi dxi-table-row",
			items: [
				{
					id: "add-row",
					value: locale.addRow,
					icon: "dxi dxi-table-row-plus-before",
				},
				{
					id: "remove-row",
					value: locale.removeRow,
					icon: "dxi dxi-table-row-remove",
				},
			],
		},
		{
			id: "sort",
			value: locale.sort,
			icon: "dxi dxi-format-line-spacing",
			items: [
				{
					id: "asc-sort",
					value: locale.ascSort,
					icon: "dxi dxi-sort-variant dhx-sort-acs",
				},
				{
					id: "desc-sort",
					value: locale.descSort,
					icon: "dxi dxi-sort-variant",
				},
			],
		},
		{
			id: "link",
			value:`${locale.insert} ${locale.link.toLowerCase()}`,
			icon: "dxi dxi-link-variant",
		},
	];
}
export function getSheetsContextMenuStruct(multisheets: boolean): IMenuElement[] {
	return [
		{ id: "delete", value: locale.deleteSheet, icon: "dxi dxi-delete-forever", disabled: !multisheets },
		{ id: "rename", value: locale.renameSheet, icon: "dxi dxi-pencil" },
	];
}
